import { useForm, useFieldArray, Controller } from "react-hook-form";
import { motion } from "framer-motion";
import helpers from "utils/helpers";
import { IoCaretBackCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import OInputField from "components/reusable/OInputField";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import React, { useContext, useEffect, useTransition } from "react";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";

export default function AnnouncementForm() {
  const { t } = useTranslation();
  const [isPending, setTransition] = useTransition();

  const { updatePageName } = useContext(AuthContext);
  const location = useLocation();
  let defaultValue = location?.state || {};
  const isView = location?.pathname == "/announcement-manager/view";
  const navigate = useNavigate();
  const {
    register,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      price: [{ status: true, price: "", startDistance: "0", endDistance: "" }],
      priceIncrementAsPerDistance: [
        { status: true, percentage: "", min: "0", max: "" },
      ],
    },
    shouldFocusError: false,
  });

  useEffect(() => {
    updatePageName(t("ANNOUNCEMENT_MANAGER"));
  }, [location]);

  const { fields: fields1 } = useFieldArray({
    control,
    name: "price",
  });

  const { fields: fields2 } = useFieldArray({
    control,
    name: "priceIncrementAsPerDistance",
  });

  const getServiceMasterSP = async () => {
    const editItem = {
      ...location?.state,
      priceIncrementAsPerDistance:
        location?.state?.data?.priceIncrementAsPerDistance,
      price: location?.state?.data?.dropOffPriceIncrementAsPerDistance,
    };
    reset(editItem);
  };

  useEffect(() => {
    if (!isEmpty(location?.state)) {
      getServiceMasterSP();
    }
  }, [location]);

  return (
    <div className=" min-h-screen  bg-gradient-to-br from-gray-100 to-gray-200 p-6 md:p-10">
      <motion.form
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white max-w-8xl mx-auto rounded-3xl shadow-xl p-6 md:p-10 relative space-y-8"
      >
        <motion.h2
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="text-2xl md:text-2xl font-bold text-gray-800 mb-6 border-b pb-2"
        >
          View Updated Service Price
        </motion.h2>

        <div className="flex flex-col lg:flex-row gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="w-full h-full transition-shadow duration-300"
          >
            <div className="w-full transition-shadow duration-300">
              <div className="bg-white shadow-md rounded-2xl p-6">
                <div className=" p-1 max-h-[500px] overflow-y-auto ">
                  <div className="grid grid-cols-1 2xl:grid-cols-1 gap-6 ">
                    {/* Price Section */}
                    <div className="flex flex-col gap-4 border border-gray-200 rounded-xl p-4 bg-gray-50">
                      <div className="grid grid-cols-1 2xl:grid-cols-2 gap-6 ">
                        <OInputField
                          wrapperClassName="relative z-0 w-full group"
                          name="name"
                          inputLabel={
                            <>
                              {t("Service Name")}
                            </>
                          }
                          type="text"
                          value={location?.state?.serviceName}
                          errors={errors}
                          disable={true}
                        />
                        <OInputField
                          wrapperClassName="relative z-0 w-full group"
                          name="description"
                          inputLabel={
                            <>
                              {t("Title")}
                            </>
                          }
                          type="text"
                          value={location?.state?.title}
                          disable={true}
                        />
                        </div>
                         <div className="grid grid-cols-1 2xl:grid-cols-1 gap-6 ">
                        <OInputField
                          wrapperClassName="relative z-0 w-full group"
                          name="description"
                          inputLabel={
                            <>
                              {t("Description")}
                            </>
                          }
                          type="textarea"
                          rows={3}
                          value={location?.state?.description}
                          disable={true}
                        />
                      </div>
                    </div>
                    <motion.div
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.3 }}
                      className="w-full mt-4 transition-shadow duration-300 "
                    >
                      <h2 className="text-[23px] font-bold text-gray-800 mb-6 border-b pb-3">
                        {t("Base Price")}
                      </h2>
                      <div className="space-y-2 px-1 rounded-2xl border border-gray-200  bg-gray-50 shadow-md pb-1 mb-3 pt-1">
                        <motion.div
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.05 }}
                          className="p-4 border-b last:border-b-0 relative"
                        >
                          <div className="flex gap-3">
                            <div className="w-[95%] grid grid-cols-1 md:grid-cols-1 2xl:grid-cols-2 gap-6">
                              <OInputField
                                wrapperClassName="relative z-0 w-full group"
                                name="minBasePrice"
                                inputLabel={<>{t("Min Base Price")} ($)</>}
                                type="number"
                                disable={true}
                                value={location?.state?.data?.minBasePrice}
                              />
                              <OInputField
                                wrapperClassName="relative z-0 w-full group"
                                name="maxBasePrice"
                                inputLabel={<>{t("Max Base Price")} ($)</>}
                                type="number"
                                value={location?.state?.data?.maxBasePrice}
                                disable={true}
                              />
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    </motion.div>
                    <motion.div
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.3 }}
                      className="w-full mt-4 transition-shadow duration-300 "
                    >
                      <h2 className="text-[23px] font-bold text-gray-800 mb-6 border-b pb-3">
                        {t("PRICE_INCREMENT_AS_PER_RADIUS")}
                      </h2>
                      <div className="">
                        {fields2?.map((item, index) => (
                          <div
                            key={`${index}`}
                            className="space-y-2 px-1 rounded-2xl border border-gray-200  bg-gray-50 shadow-md pb-1 mb-3 pt-1"
                          >
                            <motion.div
                              key={item.id}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: index * 0.05 }}
                              className="p-4 border-b last:border-b-0 relative"
                            >
                              <div className="flex gap-3">
                                <div className="w-[95%] grid grid-cols-1 md:grid-cols-1 2xl:grid-cols-4 gap-6">
                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name="min"
                                    inputLabel={
                                      <>{t("Min Distance")} (Miles)</>
                                    }
                                    type="number"
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.min`
                                    )}
                                    disable={true}
                                  />

                                  {/* hidden */}
                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group hidden"
                                    name="min"
                                    inputLabel={
                                      <>{t("Min Distance")} (Miles)</>
                                    }
                                    type="number"
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.min`
                                    )}
                                    disable={true}
                                  />
                                  {/* hidden */}

                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name="max"
                                    inputLabel={
                                      <>{t("Max Distance")} (Miles)</>
                                    }
                                    type="number"
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.max`
                                    )}
                                    disable={true}
                                  />

                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name={"percentage"}
                                    inputLabel={
                                      <>{t("Min Price Increment")} (%)</>
                                    }
                                    type="number"
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.minPercentage`
                                    )}
                                    disable={isView}
                                  />
                                  <OInputField
                                    wrapperClassName="relative z-0 w-full group"
                                    name={"percentage"}
                                    inputLabel={
                                      <>{t("Max Price Increment")} (%)</>
                                    }
                                    type="number"
                                    register={register(
                                      `priceIncrementAsPerDistance.${index}.maxPercentage`
                                    )}
                                    disable={isView}
                                  />
                                </div>
                              </div>
                            </motion.div>
                          </div>
                        ))}
                      </div>
                    </motion.div>

                    {location?.state?.data?.isdropLocation && (
                      <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="w-full mt-4 transition-shadow duration-300 "
                      >
                        <h2 className="text-[23px] font-bold text-gray-800 mb-6 border-b pb-3">
                          {t("DROPOFF_INFORMATION")}
                        </h2>

                        <div className="">
                          {fields1?.map((item, index) => (
                            <div
                              key={`${index}`}
                              className="space-y-2 px-1 rounded-2xl border border-gray-200  bg-gray-50 shadow-md pb-1 mb-3 pt-1"
                            >
                              <motion.div
                                key={item.id}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.05 }}
                                className="p-4 border-b last:border-b-0 relative"
                              >
                                <div className="flex gap-3">
                                  <div className="w-[95%] grid grid-cols-1 md:grid-cols-1 2xl:grid-cols-4 gap-6">
                                    <OInputField
                                      wrapperClassName="relative z-0 w-full group"
                                      name="startDistance"
                                      inputLabel={
                                        <>{t("Start Distance")} (Miles)</>
                                      }
                                      type="number"
                                      disable={true}
                                      register={register(
                                        `price.${index}.startDistance`
                                      )}
                                    />

                                    <OInputField
                                      wrapperClassName="relative z-0 w-full group"
                                      name="endDistance"
                                      inputLabel={
                                        <>{t("End Distance")} (Miles)</>
                                      }
                                      type="number"
                                      register={register(
                                        `price.${index}.endDistance`
                                      )}
                                      disable={true}
                                    />

                                    <OInputField
                                      wrapperClassName="relative z-0 w-full group"
                                      name={"price"}
                                      inputLabel={
                                        <>{t("MIN_SERVICE_PRICE")} ($)</>
                                      }
                                      type="number"
                                      register={register(
                                        `price.${index}.minPrice`
                                      )}
                                      disable={isView}
                                    />
                                    <OInputField
                                      wrapperClassName="relative z-0 w-full group"
                                      name={"price"}
                                      inputLabel={
                                        <>{t("MAX_SERVICE_PRICE")} ($)</>
                                      }
                                      type="number"
                                      register={register(
                                        `price.${index}.maxPrice`
                                      )}
                                      disable={isView}
                                    />
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
        <div className="flex gap-4 justify-center">
          <Link to="/announcement-manager">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="button"
              title={"Back"}
              onClick={() => reset()}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition flex items-center gap-1"
            >
              <IoCaretBackCircleOutline size={18} />
              {t("O_BACK")}
            </motion.button>
          </Link>

          {helpers.andOperator(
            !isView,
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              title={"Submit"}
              type="submit"
              className="px-6 py-2 bg-gradientTo text-sm text-white rounded-md  transition flex items-center gap-1"
              disabled={isPending}
            >
              {helpers.ternaryCondition(
                isPending,
                "Submiting...",
                <>{t("Submit")}</>
              )}
            </motion.button>
          )}
        </div>
      </motion.form>
    </div>
  );
}
